import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import CustomerActions from '@Actions/customerActions';
import {
  Table, Tooltip, Drawer, Dropdown, Checkbox, notification, Button, Menu,
  Tag,
  Divider,
  Popconfirm,
} from 'antd';
import { ControlOutlined, FilterOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import {
  toISTDate, CountryCodes, entityNameEnum, filterTypeEnums,
} from '@Apis/constants';
import searchIcon from '@Images/icons/icon-search.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import CustomerForm from '../CreateCustomer/CustomerForm';
import BulkImportCustomers from './BulkImportCustomers';
import AdvanceFilter from '../../../../Common/AdvanceFilter';
import PRZText from '../../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import useCheckPortrait from '../../../../../hooks/useCheckPortrait';
import UserSavedFilterViewSelector from '../../../../Common/UserSavedFilterViewSelector';
import './style.scss';

function CustomerList({
  customers, getCustomersLoading, user, getCustomers, history, getDocCFV2, getDocCFV2Success, getDocCFV2V2Loading, customFieldsProps, getOrgUsers, orgUsers,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
  const [showUpdateCustomerModal, setShowUpdateCustomerModal] = useState(false);
  const [bulkUploadCustomers, setBulkUploadCustomers] = useState(true);
  const [showBulkImportDrawer, setShowBulkImportDrawer] = useState(false);
  const [call, setCall] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [fixedColumns, setFixedColumns] = useState(['NAME']);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [visible, setVisible] = useState(false);
  const [openAdvanceProductFiltersDrawer, setOpenAdvanceProductFiltersDrawer] = useState(false);
  const [advanceFilters, setAdvanceFilters] = useState("");
  const [visibleColumns, setVisibleColumns] = useState(
    localStorage.getItem('prcz-page-columns-customer')
      ? JSON.parse(localStorage.getItem('prcz-page-columns-customer'))
      : {
        INTERNAL_CUST_CODE: {
          label: 'Customer Code',
          visible: true,
        },
        NAME: {
          label: 'Customer Name',
          visible: true,
        },
        CUSTOMER_TYPE: {
          label: 'Customer Type',
          visible: true,
        },
        EMAIL: {
          label: 'Email',
          visible: true,
        },
        CONTACT: {
          label: 'Contact Number',
          visible: true,
        },
        TAX_ID: {
          label: 'Tax ID',
          visible: true,
        },
        LINKED_VENDOR: {
          label: 'Linked Vendor',
          visible: true,
        },
        STATE: {
          label: 'State',
          visible: true,
        },
        CITY: {
          label: 'City',
          visible: false,
        },
        COUNTRY: {
          label: 'Country',
          visible: false,
        },
        CREATED_DATE: {
          label: 'Created Date',
          visible: true,
        },
        SALES_MANAGER: {
          label: 'Sales Manager',
          visible: true,
        },
      },
  );

  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState(null);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const customFieldOptions = useMemo(() => {
    if (customFieldsProps) {
      const data = { customFields: [...customFieldsProps?.data?.document_custom_fields, ...customFieldsProps?.data?.document_line_custom_fields] }
      const fieldOptions = data?.customFields?.filter((item) => item.is_active)
      return fieldOptions;
    }
  }, [customFieldsProps]);

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const onMenuClick = (e) => {
    if (e.key === '1' || e.key === 1) {
      setShowBulkImportDrawer(true);
      setBulkUploadCustomers(true);
    }
    else if (e.key === '2' || e.key === 2) {
      setShowBulkImportDrawer(true);
      setBulkUploadCustomers(false);
    }
  };

  const items = [
    {
      key: '1',
      label: 'Upload New Customers',
    },
    {
      key: '2',
      label: 'Update Existing Customers',
    },
  ];

  const getCustomerColumns = () => {
    const customerListColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/sales/customer/view/${record.customer_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <div>
      //             <div
      //               style={{
      //                 fontWeight: '600',
      //                 fontSize: '12px',
      //                 cursor: 'pointer',
      //               }}
      //             >
      //               {record.customer_info
      //                 ? `${record.customer_info?.customer_name}`
      //                 : ''}
      //             </div>
      //             {record?.customer_info?.billing_address_details?.city && (
      //               <div>
      //                 {record?.customer_info?.billing_address_details?.city
      //                   || ''}
      //               </div>
      //             )}
      //           </div>
      //           <div
      //             className={`mobile-list__item-status ${record?.is_active ? 'status-tag' : 'status-tag__inactive'
      //               }`}
      //           >
      //             {record?.is_active ? 'Active' : 'Inactive'}
      //             {' '}
      //           </div>
      //         </div>
      //         {record?.customer_info?.email_address && (
      //           <div className="mobile-list__item-info">
      //             <div>
      //               <MailOutlined />
      //             </div>
      //             <div style={{ marginLeft: '5px', marginTop: '2px' }}>
      //               {`${record?.customer_info?.email_address || '-'
      //                 }`}
      //             </div>
      //           </div>
      //         )}
      //         {record?.customer_info?.phone_number && (
      //           <div className="mobile-list__item-info">
      //             <div>
      //               <PhoneOutlined />
      //             </div>
      //             <div style={{ marginLeft: '5px', marginTop: '2px' }}>
      //               {`${record?.customer_info?.phone_number || '-'
      //                 }`}
      //             </div>
      //           </div>
      //         )}
      //         <H3Text
      //           text={`Customer Type - ${record?.customer_info?.customer_type}`}
      //           className="mobile-list__item-info"
      //         />
      //         <div className="vendor-mobile-list__item-footer">
      //           <div />
      //           <div className="mobile-list__item-footer-right" style={{}}>
      //             {user?.user_tenants?.find(
      //               (item) => item?.tenant_id === record?.tenant_id,
      //             )?.shopify_location_id && (
      //                 <div>
      //               {record?.customer_info?.shopify_customer_id && (
      //                     <Tooltip
      //                 title={`Last sync ${toISTDate(
      //                         record?.customer_info?.shopify_updated_at,
      //                       ).format('DD/MM/YYYY hh:mm A')}`}
      //                 overlayClassName="font-12"
      //                 placement="topRight"
      //               >
      //                 <a
      //                         href={`https://admin.shopify.com/store/${record?.customer_info?.shopify_shop_name?.split(
      //                           '.',
      //                         )?.[0]
      //                           }/customers/${record?.customer_info?.shopify_customer_id
      //                           }`}
      //                         target="_blank"
      //                         rel="noreferrer"
      //                       >
      //                         <div className="img-shopify_customers-wrapper">
      //                     <img
      //                             src={ShopifyIcon}
      //                             alt="Shopify"
      //                             className="img-shopify_customers"
      //                           />
      //                     <div className="green-indicator" />
      //                   </div>
      //                       </a>
      //               </Tooltip>
      //                   )}
      //             </div>
      //               )}
      //           </div>
      //         </div>
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/sales/customer/view/${record.customer_id}`}
                >
                  <PRZText
                    text={`#${record?.customer_info?.internal_cust_code || '-'}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  text={record?.is_active ? 'Active' : 'Inactive'}
                  className={`mobile-list__card__status ${record?.is_active ? 'status-tag__active' : 'status-tag__inactive'}`}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Link
                  // to={`/sales/customer/view/${record.customer_id}`}
                  >
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={record.customer_info?.customer_name?.trim() || '-'}
                    />
                  </Link>
                </div>

                {record?.customer_info?.email_address && (
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={`Email: ${record?.customer_info?.email_address}`}
                      />
                    )}
                    color="white"
                  >
                    <PRZText
                      text={`Email: ${record?.customer_info?.email_address}`}
                      className="mobile-list__card_item-details"
                    />
                  </Tooltip>
                )}

                {record?.customer_info?.phone_number && (
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={`Phone: ${record?.customer_info?.phone_number}`}
                      />
                    )}
                    color="white"
                  >
                    <PRZText
                      text={`Phone: ${record?.customer_info?.phone_number}`}
                      className="mobile-list__card_item-details"
                    />
                  </Tooltip>
                )}
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Customer Type" />
                  )}
                >
                  <PRZText
                    text={record?.customer_info?.customer_type.toProperCase() || '-'}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                {/* {record.product_type && (
                  <div
                    className="mobile-list__card_footer__other-status"
                    style={{
                      backgroundColor: Helpers.getProductType(record.product_type)
                        ?.color,
                    }}
                  >
                    {Helpers.getProductType(record.product_type)?.text}
                  </div>
                )} */}

                <div className="mobile-list__card_footer__actions-button_wrapper">
                  {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && (
                    <div className="card_footer__actions-button">
                      {record?.zoho_customer_id
                        ? (
                          <Popconfirm
                            title={(
                              <span className="font-12">
                                Sync with Zoho Books
                              </span>
                            )}
                            description={(
                              <span className="font-12">
                                Last sync
                                {' '}
                                {toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                              </span>
                            )}
                            onConfirm={() => (
                              window.open(`https://books.zoho.in/app#/contacts/${record?.zoho_customer_id}`, '_blank', 'noopener,noreferrer')
                            )}
                            onCancel={() => { }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div className="img-shopify__wrapper card_footer__actions-button_image__wrapper">
                              <img
                                src={ZohoBooks}
                                alt="Zoho"
                                className="img-shopify card_footer__actions-button_image"
                              />
                              <div className="green-indicator" />
                            </div>
                          </Popconfirm>
                        )
                        : (
                          <div>
                            <Tooltip
                              title="This customer is not synced with Zoho Books."
                              overlayClassName="font-12"
                              placement="topRight"
                            >
                              <div className="img-shopify__wrapper card_footer__actions-button_image__wrapper">
                                <img
                                  src={ZohoBooks}
                                  alt="Zoho"
                                  className="img-shopify img-shopify__disabled card_footer__actions-button_image"
                                />
                                <div className="green-indicator red-indicator" />
                              </div>
                            </Tooltip>
                          </div>
                        )}
                    </div>
                  )}
                  {record?.customer_info?.shopify_customer_id && (
                    <div className="card_footer__actions-button">
                      <Popconfirm
                        title={(
                          <span className="font-12">
                            Sync with Shopify
                          </span>
                        )}
                        description={(
                          <span className="font-12">
                            Last sync
                            {' '}
                            {toISTDate(
                              record?.customer_info?.shopify_updated_at,
                            ).format('DD/MM/YYYY hh:mm A')}
                          </span>
                        )}
                        onConfirm={() => (
                          window.open(`https://admin.shopify.com/store/${record?.customer_info?.shopify_shop_name?.split('.')?.[0]
                            }/customers/${record?.customer_info?.shopify_customer_id}`, '_blank', 'noopener,noreferrer')
                        )}
                        onCancel={() => { }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <div className="img-shopify__wrapper card_footer__actions-button_image__wrapper">
                          <img
                            src={ShopifyIcon}
                            alt="Shopify"
                            className="img-shopify card_footer__actions-button_image"
                          />
                        </div>
                      </Popconfirm>
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedCustomer(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'CUSTOMER #',
        fixed: 'left',
        render: (text, record) => (
          <div className="column-nummber__wrapper min-width-100">
            {record?.customer_info?.internal_cust_code || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.INTERNAL_CUST_CODE.visible ? 'display-none' : '',
      },
      {
        title: 'NAME',
        key: 'name',
        render: (text, record) => (
          <div className="min-width-50">
            {`${record?.customer_info?.customer_name ? record?.customer_info?.customer_name : '-'} ${record?.customer_info?.billing_address_details?.city ? record?.customer_info?.billing_address_details?.city : '-'}`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.NAME?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'CUSTOMER TYPE',
        key: 'name',
        render: (text, record) => (
          <div className="min-width-115">
            {record?.customer_info?.customer_type ? record?.customer_info?.customer_type : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER_TYPE?.visible ? 'display-none' : '',
      },
      {
        title: 'EMAIL',
        render: (text, record) => (
          <div className="min-width-50">
            {record?.customer_info?.email_address ? record?.customer_info?.email_address : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.EMAIL?.visible ? 'display-none' : '',
      },
      {
        title: 'CONTACT NUMBER',
        render: (text, record) => (
          <div className="min-width-130">
            {record?.customer_info?.phone_number ? (`${CountryCodes?.find((code) => code?.dial_code == record?.customer_info?.dial_code)?.flag} +${record?.customer_info?.dial_code} ${record?.customer_info?.phone_number}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CONTACT?.visible ? 'display-none' : '',
      },
      {
        title: 'SALES MANAGER',
        render: (text, record) => (
          <div className="min-width-115">
            {record?.customer_info?.account_manager_info?.account_manager_id ? (`${record?.customer_info?.account_manager_info?.first_name} ${record?.customer_info?.account_manager_info?.last_name}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_MANAGER?.visible ? 'display-none' : '',
      },
      {
        title: 'TAX ID',
        render: (text, record) => (
          <div className="min-width-50">
            {record.customer_info.gst_number ? record.customer_info.gst_number : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TAX_ID?.visible ? 'display-none' : '',
      },
      {
        title: 'LINKED VENDOR',
        render: (text, record) => (
          <div className="associated-entity min-width-100">
            <Link to={`/vendors/view/${record?.customer_info?.seller_info?.seller_id}`} target="_blank">{record?.customer_info?.seller_info?.seller_name}</Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LINKED_VENDOR?.visible ? 'display-none' : '',
      },
      {
        title: 'CITY',
        render: (text, record) => (
          <div className="min-width-50">
            {record.customer_info.billing_address_details?.city || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CITY?.visible ? 'display-none' : '',
      },
      {
        title: 'STATE',
        render: (text, record) => (
          <div className="min-width-50">
            {record.customer_info.billing_address_details?.state || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATE?.visible ? 'display-none' : '',
      },
      {
        title: 'COUNTRY',
        render: (text, record) => (
          <div className="min-width-70">
            {record.customer_info.billing_address_details?.country || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.COUNTRY?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div className="min-width-100">
            {toISTDate(record?.customer_info?.created_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs
        ?.filter((item) => item?.is_active)
        ?.map((custom) => {
          customerListColumns.push({
            title: custom.field_name?.toUpperCase(),
            render: (record) => (
              <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
                <ViewTableCustomFields
                  customField={
                    record.custom_fields?.filter(
                      (subItem) => subItem.cf_id === custom.cf_id,
                    )?.[0]
                  }
                />
              </div>
            ),
            responsive: ['sm', 'md', 'lg', 'xxl'],
            hidden: isMobile,
            className: !visibleColumns?.[custom.cf_id]?.visible
              ? 'display-none'
              : '',
          });
        });
    }
    customerListColumns.push({
      title: '',
      key: 'action',
      className: 'list__actions-column',
      fixed: 'right',
      render: (text, record) => (
        <div
          className="list__actions"
        >
          {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && (
            <div className="list__actions-button">
              {(record?.zoho_customer_id)
                ? (
                  <Tooltip
                    title={`Last Sync ${toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                    overlayClassName="font-12"
                    placement="topRight"
                  >
                    <a
                      href={`https://books.zoho.in/app#/contacts/${record?.zoho_customer_id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="img-shopify__wrapper">
                        <img
                          src={ZohoBooks}
                          alt="Zoho"
                          className="img-shopify"
                        />
                        <div className="green-indicator" />
                      </div>
                    </a>
                  </Tooltip>
                )
                : (
                  <div>
                    <Tooltip
                      title="This customer is not synced with Zoho Books."
                      overlayClassName="font-12"
                      placement="topRight"
                    >
                      <div className="img-shopify__wrapper">
                        <img
                          src={ZohoBooks}
                          alt="Zoho"
                          className="img-shopify img-shopify__disabled"
                        />
                        <div className="green-indicator red-indicator" />
                      </div>
                    </Tooltip>
                  </div>
                )
              }
            </div>
          )}
          {record?.customer_info?.shopify_customer_id && (
            <div className="list__actions-button">
              <Tooltip
                title={`Last sync ${toISTDate(
                  record?.customer_info?.shopify_updated_at,
                ).format('DD/MM/YYYY hh:mm A')}`}
                overlayClassName="font-12"
                placement="topRight"
              >
                <a
                  href={`https://admin.shopify.com/store/${record?.customer_info?.shopify_shop_name?.split('.')?.[0]
                    }/customers/${record?.customer_info?.shopify_customer_id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="img-shopify__wrapper">
                    <img
                      src={ShopifyIcon}
                      alt="Shopify"
                      className="img-shopify"
                    />
                    <div className="green-indicator" />
                  </div>
                </a>
              </Tooltip>
            </div>
          )}

          {/* { Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, */}
          {/*  Helpers.permissionTypes.UPDATE, user) && ( */}
          {/*  <div */}
          {/*    className="list__actions-button" */}
          {/*    onClick={() => { */}
          {/*      setShowUpdateCustomerModal(true); */}
          {/*      setShowUpdateCustomerModal(true); */}
          {/*      setSelectedCustomer(record); */}
          {/*    }} */}
          {/*  > */}
          {/*    <EditOutlined /> */}
          {/*  </div> */}
          {/* )} */}
          {!isPortrait && (
            <div
              className="list__actions-button list__actions-button-dark"
              onClick={() => history.push(`/sales/customer/view/${record.customer_id}`)}
            >
              View
            </div>
          )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
    });
    return customerListColumns.filter((item) => !item.hidden);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim() || '',
          identity: orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase() || '',
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'advance_filter',
        filter_value: Helpers.getValueFromUrl('advance_filter') || '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'accountManager',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'advance_filter',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.CUSTOMER,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const pushParamsToUrl = (page, limit, word, accountManager, advanceFilters, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (accountManager) url += `&accountManager=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (advanceFilters) url += `&advance_filter=${advanceFilters}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {

      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword || '');
        setKeyword(tempFilterValues.keyword || '');
        setSelectedAssignee(tempFilterValues.accountManager || []);
        setAdvanceFilters(tempFilterValues.advance_filter || '');
        setShowNewCustomerModal(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ)?.join(','), () => { });
      setSelectedFilterView(systemDefaultUserView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedAssignee, advanceFilters, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'CUSTOMERS',
      };

      getDocCFV2(payload);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getCustomers(
        Helpers.getValueFromUrl('keyword'),
        user?.tenant_info?.tenant_id,
        Helpers.getValueFromUrl('page'),
        Helpers.getValueFromUrl('limit'),
        null, null, Helpers.getValueFromUrl('accountManager'), null, null, Helpers.getValueFromUrl('advance_filter'),
      );
    }
  }, [searchKeyword, currentPage, limit, selectedAssignee, advanceFilters, selectedFilterView]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields
        ?.filter((item) => item?.is_active)
        ?.map((customField) => {
          columns[customField.cf_id] = {
            label: customField?.field_name,
            visible:
              JSON.parse(localStorage.getItem('prcz-page-columns-customer'))?.[
                customField.cf_id
              ]?.visible || false,
          };
        });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for customers name.."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    {/* {Helpers.getPermission(
                      Helpers.permissionEntities.CUSTOMER,
                      Helpers.permissionTypes.CREATE,
                      user,
                    ) && (
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New Customer"
                        onClick={() => {
                          setShowNewCustomerModal(true);
                        }}
                        customClass="customers__header__add-button"
                      />
                    )} */}
                    {/* &nbsp;&nbsp; */}
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ Add Customer"
                      onClick={() => {
                        setShowNewCustomerModal(true);
                        getDocCFV2Success(null);
                      }}
                      customClass="add-button"
                    />
                    <Dropdown
                      overlay={<Menu items={items} onClick={onMenuClick} />}
                      trigger={['hover']}
                      open={visible}
                      onOpenChange={handleVisibleChange}
                    >
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ Upload Customer"
                        customClass="add-button"
                        onClick={() => setVisible(!visible)}
                      />
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;

                    setKeyword(tempFilterValues.keyword);
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setSelectedAssignee(tempFilterValues.accountManager);
                    setAdvanceFilters(tempFilterValues.advance_filter);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.CUSTOMER}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {advanceFilters?.length > 0 && (
                  <Tag closable onClose={() => { setAdvanceFilters(""); setCurrentPage(1); }} color="#2d7df7">
                    Advanced Filters
                  </Tag>
                )}
                {searchKeyword && searchKeyword?.length > 0 && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }}>
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text
                        text={`${customers && customers.count ? customers.count : '0'
                          } Total Customers`}
                        className=""
                      />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                          />
                        </div>
                      </div>
                      <div className="doc-list__action-buttons">
                        <div className="action-button" onClick={() => setOpenAdvanceProductFiltersDrawer(true)}>
                          <H3Text
                            text="Advanced Filters"
                            className="action-button-text"
                          />
                          <FilterOutlined />
                        </div>
                      </div>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text
                                text="Visible Columns"
                                className="custom-columns__content-title"
                              />
                              {Object.keys(visibleColumns)
                                .filter((item) => visibleColumns[item]?.visible)
                                ?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(
                                          JSON.stringify(visibleColumns),
                                        );
                                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                        localStorage.setItem(
                                          'prcz-page-columns-customer',
                                          JSON.stringify(visibleColumnsCopy),
                                        );
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))}
                            </div>
                            {Object.keys(visibleColumns).filter(
                              (item) => !visibleColumns[item]?.visible,
                            )?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text
                                  text="Hidden Columns"
                                  className="custom-columns__content-title"
                                />
                                {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(
                                          JSON.stringify(visibleColumns),
                                        );
                                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                        localStorage.setItem(
                                          'prcz-page-columns-customer',
                                          JSON.stringify(visibleColumnsCopy),
                                        );
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                loading={
                  getCustomersLoading
                  || getDocCFV2V2Loading
                  || savedFilterViewsLoading
                }
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && customers && !!customers.customers?.length ? { x: 'max-content', y: 'calc(100dvh - 170px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && customers && !!customers.customers?.length}
                columns={getCustomerColumns()}
                dataSource={
                  customers && customers.customers ? customers.customers : []
                }
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: customers ? customers.count : 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewCustomerModal}
        onClose={() => setShowNewCustomerModal(false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text text="Add New Customer" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowNewCustomerModal(false)}
            />
          </div>
        </div>
        <CustomerForm
          callback={() => {
            getCustomers(
              Helpers.getValueFromUrl('keyword'),
              user?.tenant_info?.tenant_id,
              currentPage,
              10,
            );
            setShowNewCustomerModal(false);
          }}
        />
      </Drawer>
      <Drawer
        title="Update Customer Information"
        open={showUpdateCustomerModal}
        onClose={() => setShowUpdateCustomerModal(false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text
              text="Update Customer Information"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowUpdateCustomerModal(false)}
            />
          </div>
        </div>
        <CustomerForm
          callback={() => {
            getCustomers(
              Helpers.getValueFromUrl('keyword'),
              user?.tenant_info?.tenant_id,
              currentPage,
              10,
            );
            setShowUpdateCustomerModal(false);
          }}
          selectedCustomer={selectedCustomer}
        />
      </Drawer>
      <Drawer
        placement="right"
        onClose={() => setShowBulkImportDrawer(false)}
        open={showBulkImportDrawer}
        width="745px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '700px' }}>
            <H3Text text={bulkUploadCustomers ? "Import Customers" : "Update Customers"} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowBulkImportDrawer(false)} />
          </div>
        </div>
        <BulkImportCustomers
          isBulkUploadCustomers={bulkUploadCustomers}
          callback={() => {
            setShowBulkImportDrawer(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <Drawer
        open={openAdvanceProductFiltersDrawer}
        width="820px"
        mask
        onClose={() => setOpenAdvanceProductFiltersDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '770px' }}>
            <H3Text text="Apply Advanced Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenAdvanceProductFiltersDrawer(false)} />
          </div>
        </div>
        <AdvanceFilter
          customFieldOptions={customFieldOptions}
          advanceFilters={advanceFilters}
          setAdvanceFilters={setAdvanceFilters}
          setOpenAdvanceProductFiltersDrawer={setOpenAdvanceProductFiltersDrawer}
          customKey="prz-advance-filter-customer"
        />
      </Drawer>
      <React.Fragment>
        <Drawer
          open={moreDetailsDrawer}
          mask
          onClose={() => setMoreDetailsDrawer(false)}
          destroyOnClose
          rootClassName="mobile__more-details_wrapper"
        >
          <div className="custom-drawer__header-wrapper">
            <div
              className="custom-drawer__header"
            >
              <H3Text
                text={`${selectedCustomer?.customer_info?.customer_name} - ${selectedCustomer?.customer_info?.internal_cust_code}`}
                className="custom-drawer__title"
              />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => setMoreDetailsDrawer(false)}
              />
            </div>
          </div>
          <MoreInfoMobileView
            customFields={selectedCustomer?.custom_fields}
            documentData={selectedCustomer}
            fields={ListScreenKeys({ documentData: selectedCustomer })}
          />
        </Drawer>
      </React.Fragment>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, CustomerReducers, CFV2Reducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  getCustomersLoading: CustomerReducers.getCustomersLoading,
  customers: CustomerReducers.customers,
  getDocCFV2V2Loading: CFV2Reducers.getDocCFV2V2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocCustomers,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (keyword, tenantId, page, limit, customerId, callback, accountManagerIds, selectedCustomerIds, excludeCustomerIds, advanceFilters) => dispatch(CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback, accountManagerIds, selectedCustomerIds, excludeCustomerIds, advanceFilters)),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (customFieldsDocV2) => dispatch(CFV2Actions.getDocCFV2Success(customFieldsDocV2)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CustomerList));
